export const handleDataImportExportTrade = (data, ids, years) => {
  if (!data.length) return {}
  const dataTable = {}

  ids.forEach((id) => {
    const dataItem = data.find((item) => item.vsicId === id)
    dataTable[id] = {
      id,
      vsicName: dataItem.vsicName,
    }
  })

  ids.forEach((id) => {
    years.forEach((year) => {
      const dataItem =
        data.find((item) => item.vsicId === id && item.year === year) || {}

      dataTable[id][`${year}-exportGrowthRate`] = dataItem.exportGrowthRate
      dataTable[id][`${year}-importGrowthRate`] = dataItem.importGrowthRate
      dataTable[id][`${year}-balanceOfTradeGrowthRate`] =
        dataItem.balanceOfTradeGrowthRate
    })
  })

  return dataTable
}

export const handleYearImportExportTrade = (years) => {
  const initTableHeader = [
    {
      title: 'industryOverview.macroeconomics.Name',
      colId: 'vsicName',
      isI18n: true,
      thStyle: {
        width: 200,
      },
    },
  ]
  years.forEach((year, index) => {
    initTableHeader[index + 1] = {
      title: year,
      colId: `${year}-vsicId`,
      childCol: [
        {
          title: 'industryOverview.macroeconomics.EXPORT',
          colId: `${year}-exportGrowthRate`,
          isI18n: true,
          tdStyle: {
            textAlign: 'right',
          },
        },
        {
          title: 'industryOverview.macroeconomics.IMPORT',
          colId: `${year}-importGrowthRate`,
          isI18n: true,
          tdStyle: {
            textAlign: 'right',
          },
        },
        {
          title: 'industryOverview.macroeconomics.BALANCE_OF_TRADE',
          colId: `${year}-balanceOfTradeGrowthRate`,
          isI18n: true,
          tdStyle: {
            textAlign: 'right',
          },
        },
      ],
    }
  })

  return initTableHeader
}

export const handleDataImportExportValue = (data, ids, years) => {
  if (!data.length) return {}

  const dataTable = {}
  ids.forEach((id) => {
    const dataItem = data.find((item) => item.vsicId === id)
    dataTable[id] = {
      id,
      vsicName: dataItem.vsicName,
    }
  })

  ids.forEach((id) => {
    years.forEach((year) => {
      const dataItem = data.find(
        (item) => item.vsicId === id && item.year === year,
      )
      dataTable[id][`${year}-export`] = dataItem.export
      dataTable[id][`${year}-import`] = dataItem.import
      dataTable[id][`${year}-balanceOfTrade`] = dataItem.balanceOfTrade
    })
  })

  return dataTable
}

export const handleYearImportExportValue = (years) => {
  const initTableHeader = [
    {
      title: 'industryOverview.macroeconomics.Name',
      colId: 'vsicName',
      isI18n: true,
      thStyle: {
        width: 200,
      },
    },
  ]
  years.forEach((year, index) => {
    initTableHeader[index + 1] = {
      title: year,
      colId: `${year}-vsicId`,
      childCol: [
        {
          title: 'industryOverview.macroeconomics.EXPORT',
          colId: `${year}-export`,
          isI18n: true,
          tdStyle: {
            textAlign: 'right',
          },
        },
        {
          title: 'industryOverview.macroeconomics.IMPORT',
          colId: `${year}-import`,
          isI18n: true,
          tdStyle: {
            textAlign: 'right',
          },
        },
        {
          title: 'industryOverview.macroeconomics.BALANCE_OF_TRADE',
          colId: `${year}-balanceOfTrade`,
          isI18n: true,
          tdStyle: {
            textAlign: 'right',
          },
        },
      ],
    }
  })
  return initTableHeader
}
